import { render, staticRenderFns } from "./ConfigItem.vue?vue&type=template&id=8daf70de"
import script from "./ConfigItem.vue?vue&type=script&lang=js"
export * from "./ConfigItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports